var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-box"},[_c('BFormInput',{class:['form-control', 'rounded-pill', _vm.customClass],attrs:{"list":"users-list","type":"search","placeholder":_vm.placeHolder},model:{value:(_vm.searchedItem),callback:function ($$v) {_vm.searchedItem=$$v},expression:"searchedItem"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }